import React, { useMemo } from "react";
import { Checkbox, Tooltip, Paper, Typography } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { IconShieldCheckFilled } from "@tabler/icons-react";

export default function ModuleSelection({
  module,
  setModule,
  loading,
  disabled,
}) {

  const handleOnChangeCheckBox = (item, value, moduleObject) => {
    if (item === "grandAccess") {
      setModule((prevData) =>
        prevData?.map((m) => {
          if (m.moduleGuid === moduleObject.moduleGuid) {
            return {
              ...m,
              grandAccess: value,
              isAdmin:
                moduleObject.isAdminOnly === true && value === true
                  ? true
                  : moduleObject.isAdminOnly === true && value === false
                  ? false :
                  value === false ? false
                  : m.isAdmin,
            };
          } else {
            return m;
          }
        })
      );
    }

    if (item === "isAdmin") {
      setModule((prevData) =>
        prevData?.map((m) => {
          if (m.moduleGuid === moduleObject.moduleGuid) {
            return {
              ...m,
              grandAccess: m.grandAccess === false ? value : m.grandAccess,
              isAdmin: value,
            };
          } else {
            return m;
          }
        })
      );
    }
  };

  return (
    <Paper
      sx={{
        p: "20px 25px",
        boxShadow: "none",
        borderRadius: "10px",
        border: "1px solid #E5E5E5",
      }}
    >
      <Typography fontWeight={600} fontSize={"0.9rem"} color="#202020" pb={"20px"}>
        Permission(s)
      </Typography>
      <DataGrid
        loading={loading}
        rows={module}
        getRowId={(row) => row.moduleGuid}
        columns={[
          {
            field: 'moduleName',
            headerName: 'Item(s)',
            flex: 1, minWidth: 150,
            sortable: false,
            renderCell: (params) => (
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                {params.row.moduleName}
                {params.row.isAdminOnly === true && (
                  <Tooltip title="Admin Module">
                    <IconShieldCheckFilled size={22} color="#7CA7AD"/>
                  </Tooltip>
                )}
              </div>
            ),
          },
          {
            field: 'grantAccess',
            headerName: 'Grant Access',
            minWidth: 120,
            sortable: false,
            renderCell: (params) => (
              <Checkbox
                checked={params.row.grandAccess}
                onChange={(e, v) => handleOnChangeCheckBox("grandAccess", e.target.checked, params.row)}
                disabled={disabled}
                size="small"
              />
            ),
          },
          {
            field: 'isAdmin',
            headerName: 'Is Admin',
            minWidth: 120,
            sortable: false,
            renderCell: (params) => (
              <Tooltip title={ params.row.isAdminOnly? "User cannot disable admin rights for the admin modules.": ""}>
                <Checkbox
                  checked={params.row.isAdmin}
                  onChange={(e, v) => handleOnChangeCheckBox("isAdmin", e.target.checked, params.row)}
                  disabled={!!params.row.isAdminOnly || disabled}
                  size="small"
                />
              </Tooltip>
            ),
          },
        ]}
        hideFooter
        disableRowSelectionOnClick
        disableColumnResize
        disableColumnMenu
        disableColumnSelector
        disableDensitySelector
      />
    </Paper>
  );
}